

import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Link } from 'react-router'
import { Link } from 'react-router-dom';
import { RiArrowDownSLine,RiMenuLine, RiCloseLine} from 'react-icons/ri';
import logo from '../assets/logo6-removebg-preview.png'
import { FaHome, FaInfoCircle, FaProductHunt, FaCertificate, FaPhone } from 'react-icons/fa';

const Header = () => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showMenuAboutUs,setShowMenuAboutUs]=useState(false);
  const [activeLink, setActiveLink] = useState('home');  // State to track active link
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLinkClick = (link) => {
    setActiveLink(link);  // Set the active link when clicked
    setMobileMenuOpen(false); // Close menu on link click
  };

  return (
    <div className="header-container">
      <img
        src={logo}
        alt="img"
        className="logo"
      />

      <div className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        {mobileMenuOpen ? <RiCloseLine size={30} /> : <RiMenuLine size={30} />}
      </div>

      <ul className={`nav-list ${mobileMenuOpen ? 'open' : ''}`}>
        <li
          className={`nav-item ${activeLink === 'home' ? 'active' : ''}`}
          onClick={() => handleLinkClick('home')}
        >
          <Link to="/home" className="nav-link">HOME</Link>
        </li>

        <li
          className={`nav-item ${activeLink === 'about-us' ? 'active' : ''}`}
          onMouseEnter={() => setShowMenuAboutUs(true)}
          onMouseLeave={() => setShowMenuAboutUs(false)}
          style={{ position: 'relative' }}
        >
          <div onClick={() => handleLinkClick('about-us')}>
            <Link to="/about us" className="nav-link">
              ABOUT US <RiArrowDownSLine style={{ marginLeft: 4 }} />
            </Link>
          </div>

          {showMenuAboutUs && (
            <ul className="submenu">
              <li>
                <Link
                  to="/about us"
                  className={`submenu-item ${activeLink === 'mission' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('mission')}
                >
                  Our Mission
                </Link>
              </li>
              <li>
                <Link
                  to="/about us"
                  className={`submenu-item ${activeLink === 'team' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('team')}
                >
                  Our Team
                </Link>
              </li>
            </ul>
          )}
        </li>

        <li
          className={`nav-item ${activeLink === 'products' ? 'active' : ''}`}
          onMouseEnter={() => setShowSubMenu(true)}
          onMouseLeave={() => setShowSubMenu(false)}
          style={{ position: 'relative' }}
          onClick={() => handleLinkClick('products')}
        >
          <Link to="/products" className="nav-link">
            PRODUCTS <RiArrowDownSLine style={{ marginLeft: 4 }} />
          </Link>

          {showSubMenu && (
            <ul className="submenu">
              <li>
                <Link
                  to="/products"
                  className={`submenu-item ${activeLink === 'category1' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('category1')}
                >
                  Core Crops
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className={`submenu-item ${activeLink === 'category2' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('category2')}
                >
                  Crops Category
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className={`submenu-item ${activeLink === 'category3' ? 'active' : ''}`}
                  onClick={() => handleLinkClick('category3')}
                >
                  About Crops
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li
          className={`nav-item ${activeLink === 'certificates' ? 'active' : ''}`}
          onClick={() => handleLinkClick('certificates')}
        >
          <Link to="/certificates" className="nav-link">CERTIFICATES</Link>
        </li>
        <li
          className={`nav-item ${activeLink === 'contact us' ? 'active' : ''}`}
          onClick={() => handleLinkClick('contact us')}
        >
          <Link to="/contact us" className="nav-link">CONTACT US</Link>
        </li>

      </ul>
    </div>
  );
};

export default Header;
